import cn from 'classnames'
import * as React from 'react'
import { useIntl } from '@/intl'
import formInputStyles from '@/scopes/checkout/components/PersonalDetailsForm/Inputs/FormInput.module.css'
import { useTrackFieldValidation } from '@/scopes/checkout/components/PersonalDetailsForm/useTrackFieldValidation'
import { TextInput } from '@/scopes/common/components/FormElements/TextInput'
import styles from '../Form.module.css'

export function CityNameInput({
  name,
  pattern,
  required,
}: {
  name: string
  pattern?: string
  required?: boolean
}) {
  const intl = useIntl()
  useTrackFieldValidation(name)

  return (
    <TextInput
      name={name}
      label={intl.formatMessage({ id: 'checkout_steps_participants_form_field_label_city_name' })}
      required={required}
      requiredErrorMessage={intl.formatMessage({ id: 'checkout_steps_participants_form_field_required_error_message_city_name' })}
      pattern={pattern}
      patternErrorMessage={
        intl.formatMessage({ id: 'checkout_steps_participants_form_field_pattern_error_message_city_name' })
      }
      formFieldClass={cn(styles.personalDetailsFormField, formInputStyles.formFieldM)}
    />
  )
}
